import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ICountry } from 'src/app/applicant/models';
import { RegisterService } from 'src/app/auth/services/register.service';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { SharedService } from 'src/app/shared/services';
import { CreateVendor } from '../../models';
import { UserServiceAdmin } from 'src/app/users/services/user-service-admin';
import { Router, ActivatedRoute } from '@angular/router';
import { LookupCategory, MSAType } from 'src/app/shared/enums/EnumsVMS';
import { JwtService } from 'src/app/auth/services';
import { DocViewerDialogComponent } from 'src/app/doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
import { User} from '../../../auth/models';
@Component({
  selector: 'app-create-vendor',
  templateUrl: './create-vendor.component.html',
  styleUrls: ['./create-vendor.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class CreateVendorComponent implements OnInit {
  createVendorForm: FormGroup;
  entityTypes: ILookupCategory;
  categoryName;
  public selectedEntityTypeId: Array<any> = [];
  entityDescription: string;
  entityTypeId: any;
  isSqlComments: boolean = false;
  vendorNameAvail: any;
  taxIdAvail: any;
  vendorEmail: any;
  vendorEmailAvail: any;
  paymentTerms:ILookupCategory;
  paymentTermsId: any;
  clientListForRegistration;
  clientIdOnRegistration;
  selectedClientValidOnRegistration: boolean = true;
  allowedEmailList = ['gmail', 'yahoo', 'hotmail', 'hubspot', 'sendinblue', 'protonmail', 'outlook', 'zoho', 'aol', 'mail', 'gmx', 'icloud', 'yandex'];
  emailEntityInvalid: boolean = false;
  entityTypeEdit: string;
  taxIdNumber: string;
  taxIdNumberLength: number;
  vendorName: string;
  companyId: number = 0;
  userId: number = 0;
  stateId: any = 0;
  isVendorAvailability: boolean = false;
  isSaveAvailable: boolean = false;
  isVendorPhoneUniqueNumbers: boolean = false;
  isVendorPhoneNumberValid: boolean = false;
  vendorPhoneExtDisabled:boolean = true;
  forIndividual: boolean = false;
  isFaxUniqueNumbers: boolean = false;
  isFaxNumberValid: boolean = false;
  public selectedStateId: Array<any> = [];
  states: any;
  countries: ICountry[];
  zipCode: any;
  disabled: boolean = true;
  isSqlCommentsOnFirstName: boolean = false;
  isSqlCommentsOnMiddleName: boolean = false;
  isSqlCommentsOnLastName: boolean = false;
  adminEmail: any;
  adminEmailAvail: any;
  isUserPhoneNumberValid: boolean = false;
  isUserPhoneUniqueNumbers: boolean = false;
  phoneExtDisabled:boolean = true;
  entityTypeEnable: boolean = true;
  paymentTermsEnable: boolean = true;
  public selectedPaymentTermsId:Array<any> = [];
  disableVendorEmail: boolean = false;
  isValidateVendorCategory:boolean = false;
  lastYear: any;
  last2YearBefore: any;
  last3YearBefore: any;
  showW9FormFilePreview: boolean = false;
  showDDFormFilePreview: boolean = false;
  showMSAFormFilePreview: boolean = false;
  showCOIFormFilePreview: boolean = false;
  showW9FormFilePreviewEnable: boolean = false;
  showDDFormFilePreviewEnable: boolean = false;
  showMSAFormFilePreviewEnable: boolean = false;
  showCOIFormFilePreviewEnable: boolean = false;
  w9FileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  ddFileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  coiFileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  msaFileDocUrl: string = "https://dvmsstorage.blob.core.windows.net/applicant-document-files/APP000009834/";
  w9FormFileName: string;
  showW9FormFile: boolean = false;
  ddAuthorizationFileName: string;
  showDDAuthorizationFile: boolean = false;
  msaFileName: string;
  showMsaFile: boolean = false;
  uploadedInsuranceFile: File;
  isInsurancefileShowsuccessmsg: boolean = false;
  Insurancefileuploadmessage: string;
  showInsuranceFile: boolean = false;
  InsuranceFileExtension: string;
  InsuranceUploadedPath: string;
  splittedInsuranceUploadedPath: string[];
  InsurancepdfSrc;
  showInsurancePreview: boolean = false;
  insuranceFileName: string;
  w9FormValid: boolean = true;
  ddAuthorizationValid: boolean = true;
  msaValid: boolean = true;
  coiValid: boolean = true;
  uploadedFile: File;
  uploadedDDFile: File;
  W9formUploadedPath: string;
  splittedW9formUploadedPath: string[];
  pdfSrc;
  showPreview: boolean = false;
  DDUploadedPath: string;
  splittedDDUploadedPath: string[];
  DDpdfSrc;
  showDDPreview: boolean = false;
  w9fileuploadmessage: any;
  isw9fileShowsuccessmsg: boolean = false;
  w9FormFileExtension: string;
  isDDfileShowsuccessmsg: boolean = false;
  DDfileuploadmessage: string;
  DDFileExtension: string;
  isMSAfileShowsuccessmsg: boolean = false;
  MSAfileuploadmessage: string;
  MSAFileExtension: string;
  MSAUploadedPath: string;
  splittedMSAUploadedPath: string[];
  MSApdfSrc;
  showMSAPreview: boolean = false;
  uploadedMSAFile: File;
  userName: string;
  isShowCertificateofInsurance = false;
  minExpDate: Date;
  msaTooltipMsg: string = "This document requires your signature.Please download the given document,complete the necessary information, sign it, and upload it back to us";
  invoiceTerms: ILookupCategory;
  invoiceTermsId: any;
  arrInvoiceTerms;
  invoiceTermEnable:boolean = false;
  public selectedInvoiceTermsId: Array<any> = [];
  loggedInUserProfile: User;
  MSATypes: ILookupCategory;
  arrMSAType;
  MSATypeId: any;
  MSATypeEnable:boolean = false;
  public selectedMSATypeId: Array<any> = [];
  insuranceExhibit:ILookupCategory;
  arrInsuranceExhibit;
  insuranceExhibitId: any;
  insuranceExhibitEnable:boolean = false;
  public selectedInsuranceExhibitId: Array<any> = [];
  constructor(private fb:FormBuilder,
    private sharedService: SharedService,
    private registerService: RegisterService,
    private messageService: MessageService,
    private userService: UserServiceAdmin,
    private confirmationService: ConfirmationService,
    private jwtService:JwtService,
    private dialogService: DialogService,
    private router: Router){
      this.countries = [
        { name: 'USA', code: 'USA' },
        { name: 'India', code: 'IN' },
        { name: 'Pakistan', code: 'PAK' },
        { name: 'Istanbul', code: 'IST' },
        { name: 'Paris', code: 'PRS' }
      ];
  }

  initialSetup(){
    this.createVendorForm = this.fb.group({
      vendorName: new FormControl('', [Validators.required]),
      taxIdNumber: new FormControl(''),
      ssnNumber:new FormControl('',[Validators.minLength(9)]),
      //vendorEmailId: ['', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]],
      // vendorEmailId: ['', [Validators.required, Validators.email]],
      vendorEmailId: ['', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]],
      vendorPhoneNumber: new FormControl('',[Validators.required]),
      vendorPhoneExtNumber: new FormControl('', [Validators.pattern(VMSConstants.phoneExtValidator)]),
      faxNumber: new FormControl(''),
      webAddress: new FormControl('',[Validators.pattern(VMSConstants.urlRegex)]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      zipCode: new FormControl('', [Validators.required,Validators.pattern(VMSConstants.zipcodeValidator)]),
      zipCodeExt: new FormControl('', [Validators.pattern(VMSConstants.zipcodeExtValidator)]),
      firstName: new FormControl('',[Validators.required]),
      middleName: new FormControl(''),
      lastName: new FormControl('',[Validators.required]),
      //adminEmailId: new FormControl('',[Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
      // adminEmailId: new FormControl('',[Validators.required,Validators.email]),
      adminEmailId: ['', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]],
      distributionEmail: ['',[Validators.pattern(VMSConstants.emailValidator)]],
      phoneNumber: new FormControl('',[Validators.required]),
      extNumber: new FormControl(''),
      companyEstablishment: new FormControl(''),
      glEffDate: [],
      glExpDate: [],
      alEffDate: [],
      alExpDate: [],
      ulEffDate: [],
      ulExpDate: [],
      wcEffDate: [],
      wcExpDate: [],
      plEffDate: [],
      plExpDate: [],
      comments: [''],
    })
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.getStates();
    this.initialSetup();
    this.getEntityType();
    this.getPaymentTerms();
    this.getInvoiceTerms();
    this.getMSAType();
    this.getinsuranceExhibit();
    this.getClientListForRegistration();
    this.getLoggedInUserProfile();
    this.disableVendorEmail = true;
    this.lastYear = ((new Date()).getFullYear() - 1);
    this.last2YearBefore = ((new Date()).getFullYear() - 2);
    this.last3YearBefore = ((new Date()).getFullYear() - 3);
    this.userName= undefined;
    this.minExpDate = new Date();
  }

  checkViewPermission(){
    var permission =this.jwtService.getLoggedInUserProfile();
    var allowedUser = this.sharedService.isMspUser();
    if(permission ==0 || allowedUser == false || allowedUser == undefined)
    {
     this.router.navigateByUrl('/login');
    }
  }
  getLoggedInUserProfile()
  {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }
  getEntityType() {
    this.categoryName = 'Entity Type'
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.entityTypes = data;
      //this.entityTypes = data.filter(item => item.description !== 'Individual');
    });
  }
  getClientListForRegistration() {
    this.categoryName = 'Client List For Registration';
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.clientListForRegistration = data;
    });
  }

  getClientListForRegistrationOnChange(event) {
    this.isValidateVendorCategory = true;
    this.clientIdOnRegistration = event.value.lookupOrder;
    this.selectedClientValidOnRegistration = false;
  }

  getEntityTypeOnChange(event) {
    this.entityTypeEnable = false
    this.entityTypeId = event.value.lookupId;
    this.entityDescription = event.value.description;
    this.onVendorAvailabilityCheck();
    const webAddress = this.createVendorForm.get('webAddress');
    const taxIdNumber = this.createVendorForm.get('taxIdNumber');
    const address = this.createVendorForm.get('addressLine1');
    const city = this.createVendorForm.get('city');
    const vendorName = this.createVendorForm.get('vendorName');
    const phoneNumber = this.createVendorForm.get('phoneNumber');
    const vendorPhoneNumber = this.createVendorForm.get('vendorPhoneNumber');
    const zipcode = this.createVendorForm.get('zipCode');
    const vendorEmailId = this.createVendorForm.get('vendorEmailId');
    const adminEmailId = this.createVendorForm.get('adminEmailId');
    const companyEstablishment = this.createVendorForm.get('companyEstablishment');
    if (event.value.description == 'Individual') {
      this.emailEntityInvalid = false;
      this.forIndividual = true;
   //   companyEstablishment.clearValidators();
      webAddress.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
      // vendorEmailId.setValidators([Validators.required, Validators.email]);
      // adminEmailId.setValidators([Validators.required, Validators.email]);
      vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      adminEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      taxIdNumber.setValidators([Validators.minLength(9)]);
      var arr=this.arrMSAType.filter(item => item.lookupOrder == MSAType.Standard1099);
      this.selectedMSATypeId =  arr[0];
      this.MSATypeId = arr[0].lookupOrder;
    }else{
      this.forIndividual = false;
      this.emailEntityInvalid = false;
      var arr=this.arrMSAType.filter(item => item.lookupOrder == MSAType.StandardC2C);
      this.selectedMSATypeId =  arr[0];
      this.MSATypeId = arr[0].lookupOrder;
      // vendorEmailId.setValidators([Validators.required,Validators.email]);
      // adminEmailId.setValidators([Validators.required,Validators.email]);
      vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      adminEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      webAddress.setValidators([Validators.pattern(VMSConstants.urlRegex)]);
      taxIdNumber.setValidators([Validators.required, Validators.minLength(9)]);
   //   companyEstablishment.setValidators([Validators.required]);
    }
    taxIdNumber.updateValueAndValidity();
    webAddress.updateValueAndValidity();
    vendorEmailId.updateValueAndValidity();
  //  companyEstablishment.updateValueAndValidity();
  }

  preventSqlComments(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    console.log(name);
    if (avoidString.includes(name)) {
      this.isSqlComments = true;
    }
    else {
      this.isSqlComments = false;
    }
  }

  preventSqlCommentsOnFirstName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    console.log(name);
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnFirstName = true;
    }
    else {
      this.isSqlCommentsOnFirstName = false;
    }
  }

  preventSqlCommentsOnMiddleName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    console.log(name);
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnMiddleName = true;
    }
    else {
      this.isSqlCommentsOnMiddleName = false;
    }
  }

  preventSqlCommentsOnLastName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    console.log(name);
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnLastName = true;
    }
    else {
      this.isSqlCommentsOnLastName = false;
    }
  }

  onAdminEmailAvailabilityCheck() {
    this.adminEmail = this.createVendorForm.controls['adminEmailId'].value;
    if(this.companyId == 0 && this.adminEmail != '')
    {
      this.adminEmail = this.adminEmail.trim();
      this.registerService.onVendorEmailCheck(this.adminEmail).subscribe((data: any) => {
        this.adminEmailAvail = data;
      });
    }
    if(this.companyId != 0 && this.adminEmail != '')
    {
      this.adminEmail = this.adminEmail.trim();
      this.registerService.onAdminEmailCheck(this.companyId,this.adminEmail).subscribe((data: any) => {
        this.adminEmailAvail = data;
      });
    }
  }

  get createVendorFormControl() {
    return this.createVendorForm.controls;
  }

  onVendorAvailabilityCheck(){
    if(this.entityDescription == undefined)
    {
      this.entityDescription =this.entityTypeEdit;
    }
    this.taxIdNumber = this.createVendorForm.controls['taxIdNumber'].value;
    this.vendorName = this.createVendorForm.controls['vendorName'].value;
    this.taxIdNumberLength = this.createVendorForm.controls['taxIdNumber'].value.length;
    if (this.vendorName != '' && (this.companyId == 0 || this.companyId == undefined)) {
      this.registerService.onVendorNameCheck(this.vendorName).subscribe((data: any) => {
        this.vendorNameAvail = data;
      });
    }
    if (this.entityDescription == 'Individual' && (this.companyId == 0 || this.companyId == undefined)) {
      if (this.vendorName != '' && this.stateId != 0) {
        this.registerService.onVendorAvailabilityCheck(this.vendorName, this.taxIdNumber, this.stateId).subscribe((data: any) => {

          if (data == true) {
            this.isVendorAvailability = false;
            this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Already company exists in this State with this TaxId' });
          }
          else {
            this.isVendorAvailability = true;
            this.isSaveAvailable = true;
          }

        });
      }
    }
    if (this.entityDescription != 'Individual') {
      if (this.taxIdNumberLength == 9 && this.taxIdNumber != '' && this.vendorName != '' && this.stateId != 0) {
        this.registerService.onVendorAvailabilityCheck(this.vendorName, this.taxIdNumber, this.stateId).subscribe((data: any) => {
          if (data == true) {
            this.isVendorAvailability = false;
            this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Already company exists in this State with this TaxId' });
          }
          else {
            this.isVendorAvailability = true;
            this.isSaveAvailable = true;
          }

        });
      }
     
      else if (this.entityDescription != 'Individual' && this.taxIdNumberLength < 9) {
        this.isSaveAvailable = false;
      }
    }
  }

  onCheckTaxIdNumber(){
    var taxIdNumber = this.createVendorForm.controls['taxIdNumber'].value;
    var taxIdNumberLength = this.createVendorForm.controls['taxIdNumber'].value.length;
    if (taxIdNumberLength == 9)
    {
      this.registerService.onTaxIdNumberCheck(taxIdNumber).subscribe((data: any) => {
        this.taxIdAvail = data;
      });
    } 
  }

  onVendorEmailAvailabilityCheck(){
    this.vendorEmail = this.createVendorForm.controls['vendorEmailId'].value;
    if (this.vendorEmail != '') {
      this.vendorEmail = this.vendorEmail.trim();
      this.registerService.onVendorEmailCheck(this.vendorEmail).subscribe((data: any) => {
        this.vendorEmailAvail = data;
      });
    }
  }

  emailValidator(entity): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(control.value)) {
        var domainName = control.value.split('@')[1].split('.')[0];

        if (entity == 'Individual') {
          if (this.allowedEmailList.includes(domainName) == false) {
            return { 'emailEntityInvalid': true };
          }
        }

        if (entity == 'Others') {
          if (this.allowedEmailList.includes(domainName) == true) {
            this.confirmationService.confirm({
              key:'businessEmail',
             //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
             message: '<center> You have entered free service email address, please provide a business/work email address if available. </center>',
             accept: () => {
               this.emailEntityInvalid = true;
               return { 'emailEntityInvalid': true };
             },
             reject:() =>{
               this.emailEntityInvalid = false;
             }});


          }
          else {
            this.emailEntityInvalid = false;
          }
        }
      } 
      // else {
      //   if (control.value.length > 0) {
      //     //this.emailInvalid = true;
      //     console.log('ertr',this.emailInvalid);
      //     return { 'emailInvalid': true };
      //   }
      //   else {
      //     console.log('sjkd',this.emailInvalid);
      //     this.emailInvalid = false;
      //   }
      // }
    }

  }

  vendorPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000','(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length < 14) {
      this.isVendorPhoneNumberValid = true;
    }
    else {
      this.isVendorPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isVendorPhoneUniqueNumbers = true;
    }
    else {
      this.isVendorPhoneUniqueNumbers = false;
    }

    if(avoidString.includes(name) || name.length<14)
    {
      this.vendorPhoneExtDisabled =  true;
    }
    else
    {
      this.vendorPhoneExtDisabled = false;
    }
  }

  faxUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000','(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isFaxNumberValid = true;
    }
    else {
      this.isFaxNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isFaxUniqueNumbers = true;
    }
    else {
      this.isFaxUniqueNumbers = false;
    }
  }

  userPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000','(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isUserPhoneNumberValid = true;
    }
    else {
      this.isUserPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isUserPhoneUniqueNumbers = true;
    }
    else {
      this.isUserPhoneUniqueNumbers = false;
    }

    if(avoidString.includes(name) || name.length<14)
    {
      this.phoneExtDisabled =  true;
    }
    else
    {
      this.phoneExtDisabled = false;
    }
  }

  onlyNumbers($event) {
    let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
    let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }

  getStateOnChange(event) {
    this.stateId = event.value.stateId;
    this.onVendorAvailabilityCheck();
  }

  getStates() {
    this.sharedService.getStates().subscribe((data: any) => {
      this.states = data;
    });
  }

  enableZipCodeExt() {
    this.zipCode = this.createVendorForm.controls['zipCode'].value;
    this.disabled = false;
    if (this.zipCode == '') {
      this.disabled = true;
      this.createVendorForm.controls['zipCodeExt'].setValue = undefined;
    }
  }

  save({value}: {value : CreateVendor}){
    // console.log(value);
    value.entityTypeId = this.entityTypeId;
    value.stateId = this.stateId;
    if(this.paymentTermsId != undefined)
    {
      value.paymentTermsId = this.paymentTermsId;
    }
    if(this.invoiceTermsId != undefined)
    {
      value.invoiceTermsId = this.invoiceTermsId;
    }
    else
    {
      value.invoiceTermsId =1;
    }
    value.msaTypeId = this.MSATypeId;
    value.insuranceExhibitId = 1;
    value.clientIdOnRegistration = this.clientIdOnRegistration;
    value.companyRevenueLastYear = this.lastYear + '-';
    value.companyRevenue2YearsBefore = this.last2YearBefore + '-';
    value.companyRevenue3YearsBefore = this.last3YearBefore + '-';
    if (value.glEffDate != null) {
      var glEffDate = value.glEffDate.toDateString();
      let formatedglEffDate = new Date(glEffDate);
      var strformat = formatedglEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
      }
      else
      {
        formatedglEffDate.setDate(formatedglEffDate.getDate());
      }
      value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
    }
    if (value.glExpDate != null) {
      var glExpDate = value.glExpDate.toDateString();
      let formatedglExpDate = new Date(glExpDate);
      var strformat = formatedglExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
      }
      else
      {
        formatedglExpDate.setDate(formatedglExpDate.getDate());
      }
      value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
    }
    if (value.alEffDate != null) {
      var alEffDate = value.alEffDate.toDateString();
      let formatedalEffDate = new Date(alEffDate);
      var strformat = formatedalEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
      }
      else
      {
        formatedalEffDate.setDate(formatedalEffDate.getDate());
      }
      value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
    }
    if (value.alExpDate != null) {
      var alExpDate = value.alExpDate.toDateString();
      let formatedalExpDate = new Date(alExpDate);
      var strformat = formatedalExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
      }
      else
      {
        formatedalExpDate.setDate(formatedalExpDate.getDate());
      }
      value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
    }
  
    if (value.ulEffDate != null) {
      var ulEffDate = value.ulEffDate.toDateString();
      let formatedulEffDate = new Date(ulEffDate);
      var strformat = formatedulEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
      }
      else
      {
        formatedulEffDate.setDate(formatedulEffDate.getDate());
      }
      value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
    }
    if (value.ulExpDate != null) {
      var ulExpDate = value.ulExpDate.toDateString();
      let formatedulExpDate = new Date(ulExpDate);
      var strformat = formatedulExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
      }
      else
      {
        formatedulExpDate.setDate(formatedulExpDate.getDate());
      }
      value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
    }
    if (value.wcEffDate != null) {
      var wcEffDate = value.wcEffDate.toDateString();
      let formatedwcEffDate = new Date(wcEffDate);
      var strformat = formatedwcEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
      }
      else
      {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate());
      }
      value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
    }
  
    if (value.wcExpDate != null) {
      var wcExpDate = value.wcExpDate.toDateString();
      let formatedwcExpDate = new Date(wcExpDate);
      var strformat = formatedwcExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
      }
      else
      {
        formatedwcExpDate.setDate(formatedwcExpDate.getDate());
      }
      value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
    }
  
    if (value.plEffDate != null) {
      var plEffDate = value.plEffDate.toDateString();
      let formatedplEffDate = new Date(plEffDate);
      var strformat = formatedplEffDate.toString();
      if(strformat.includes("India"))
      {
        formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
      }
      else
      {
        formatedplEffDate.setDate(formatedplEffDate.getDate());
      }
      value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
    }
    if (value.plExpDate != null) {
      var plExpDate = value.plExpDate.toDateString();
      let formatedplExpDate = new Date(plExpDate);
      var strformat = formatedplExpDate.toString();
      if(strformat.includes("India"))
      {
        formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
      }
      else
      {
        formatedplExpDate.setDate(formatedplExpDate.getDate());
      }
      value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
    }
    
    if(value.glEffDate == null || value.glEffDate == undefined || value.glExpDate == null || value.glExpDate == undefined ||
      value.alEffDate == null || value.alEffDate == undefined || value.alExpDate == null || value.alExpDate == undefined ||
      value.ulEffDate == null || value.ulEffDate == undefined || value.ulExpDate == null || value.ulExpDate == undefined || 
      value.wcEffDate == null || value.wcEffDate == undefined || value.wcExpDate == null || value.wcExpDate == undefined ||
      value.plEffDate == null || value.plEffDate == undefined || value.plExpDate == null || value.plExpDate == undefined || 
      this.splittedW9formUploadedPath ==undefined || this.splittedDDUploadedPath == undefined || this.splittedMSAUploadedPath == undefined || this.splittedInsuranceUploadedPath == undefined )
      {
        value.hasOnboardDocsCompleted = false;
      }
      else{
        value.hasOnboardDocsCompleted = true;
      }
      value.createdBy = Number(this.loggedInUserProfile.uid);
     // value.modifiedBy = Number(this.loggedInUserProfile.uid);
    this.userService.createVendorAdmin(value).subscribe((data: any) => {
      if (this.splittedW9formUploadedPath != undefined && this.userName == undefined) {
        var folderName = data.companyId;
        this.registerService.saveW9formUrl(this.splittedW9formUploadedPath[2], folderName, data.companyId).subscribe((res) => {

        });
      }
      if (this.splittedDDUploadedPath != undefined && this.userName == undefined) {
        var folderName = data.companyId;
        this.registerService.saveDDformUrl(this.splittedDDUploadedPath[2], folderName, data.companyId).subscribe((res) => {

        });
      }
      if (this.splittedMSAUploadedPath != undefined && this.userName == undefined) {
        var folderName = data.companyId;
        this.registerService.saveMSAFileUrl(this.splittedMSAUploadedPath[2], folderName, data.companyId).subscribe((res) => {

        });
      }
      if (this.splittedInsuranceUploadedPath != undefined && this.userName == undefined) {
        var folderName = data.companyId;
        this.registerService.saveInsuranceFileUrl(this.splittedInsuranceUploadedPath[2], folderName, data.companyId).subscribe((res) => {

        });
      }
        
     this.messageService.add({key:'save', severity:'success', summary:'Confirmed', detail:'Vendor created successfully'});
      setTimeout(()=>{ 
        //this.showSubmitSuccess();
       this.router.navigate(['users/vendor-search'])
     }, 2000);

     });
  }

  getPaymentTerms() {
    this.categoryName = 'Payment Terms';
      this.sharedService.getLookupMasterByCategoryId(LookupCategory.PaymentTerms).subscribe((data: any) => {
      this.paymentTerms = data;
    });
  }
  getPaymentTermsOnChange(event) {
    this.paymentTermsEnable = false
    this.paymentTermsId = event.value.lookupOrder;
  }

  
  showSubmitSuccess() {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor Added Successfully' });
  }

  onCancelVendorForm() {
    this.router.navigate(['users/vendor-search']);
  }

  onInsuranceSelect(event) {
    if(event.target.value != '')
    {
      this.InsuranceFileExtension = event.target.value;
      this.InsuranceFileExtension = this.InsuranceFileExtension.split('\\').pop().split('/').pop();
      if (this.InsuranceFileExtension.split('.').pop() == 'pdf' || this.InsuranceFileExtension.split('.').pop() == 'docx' || this.InsuranceFileExtension.split('.').pop() == 'doc' || this.InsuranceFileExtension.split('.').pop() == 'xls' || this.InsuranceFileExtension.split('.').pop() == 'xlsx' || this.InsuranceFileExtension.split('.').pop() == 'PDF' || this.InsuranceFileExtension.split('.').pop() == 'Pdf') {
        this.showInsurancePreview = true;
        this.uploadInsuranceFile();
        this.isInsurancefileShowsuccessmsg = true;
        this.coiValid = false;
        //this.Insurancefileuploadmessage = "COI uploaded successfully";
        this.Insurancefileuploadmessage  = this.InsuranceFileExtension;
      }
      else {
        this.showCOIFormFilePreviewEnable = false;
        this.coiValid = true;
        this.isInsurancefileShowsuccessmsg = false;
        this.Insurancefileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  @ViewChild('InsuranceUpload') InsurancefileInput;
  uploadInsuranceFile(): void {
    this.messageService.add({key: 'coi',severity:'success', summary:'Confirmed', detail:'COI uploaded successfully'});
    let fi = this.InsurancefileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedInsuranceFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadInsuranceFile(this.uploadedInsuranceFile).subscribe((res) => {
          this.InsuranceUploadedPath = res;
          this.splittedInsuranceUploadedPath = this.InsuranceUploadedPath.split("/");
          res = res.substring(1);
          this.coiFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showCOIFormFilePreview = false;
          // setTimeout(() => {
          //   this.showCOIFormFilePreview = true;
          // }, 5000);
          // this.showCOIFormFilePreview = false;
          this.showCOIFormFilePreviewEnable = true;
          this.InsurancefileInput.nativeElement.value = '';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.coiFileDocUrl,
              title: 'COI',
              fileName: this.InsuranceUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyInsuranceUrl(this.companyId, this.uploadedInsuranceFile).subscribe((res) => {
          this.InsuranceUploadedPath = res;
          this.splittedInsuranceUploadedPath = this.InsuranceUploadedPath.split("/");
          this.coiFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showCOIFormFilePreview = false;
          // setTimeout(() => {
          //   this.showCOIFormFilePreview = true;
          // }, 5000);
          // this.showCOIFormFilePreview = false;
          this.showCOIFormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.coiFileDocUrl,
              title: 'COI',
              fileName: this.InsuranceUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }

  onW9FormSelect(event) {
    if(event.target.value != '')
    {
      this.w9FormFileExtension = event.target.value;
      this.w9FormFileExtension = this.w9FormFileExtension.split('\\').pop().split('/').pop();
      if (this.w9FormFileExtension.split('.').pop() == 'pdf' || this.w9FormFileExtension.split('.').pop() == 'docx' || this.w9FormFileExtension.split('.').pop() == 'doc' || this.w9FormFileExtension.split('.').pop() == 'xls' || this.w9FormFileExtension.split('.').pop() == 'xlsx' || this.w9FormFileExtension.split('.').pop() == 'Pdf' || this.w9FormFileExtension.split('.').pop() == 'PDF') {
       
        this.showPreview = true;
        this.uploadW9FormFile();
  
        this.isw9fileShowsuccessmsg = true;
        this.w9FormValid = false;
        this.w9fileuploadmessage = this.w9FormFileExtension;
      }
      else {
        this.showW9FormFilePreviewEnable = false;
        this.w9FormValid = true;
        this.isw9fileShowsuccessmsg = false;
        this.w9fileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  @ViewChild('W9FormUpload') w9FormfileInput;
  uploadW9FormFile(): void {
    this.messageService.add({key: 'w9',severity:'success', summary:'Confirmed', detail:'W9 uploaded successfully'});
    let fi = this.w9FormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadW9Form(this.uploadedFile).subscribe((res) => {
          this.W9formUploadedPath = res;

          this.splittedW9formUploadedPath = this.W9formUploadedPath.split("/");
          res = res.substring(1);
          this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showW9FormFilePreview = false;
          // setTimeout(() => {
          //   this.showW9FormFilePreview = true;
          // }, 5000);
          // this.showW9FormFilePreview = false;
          this.showW9FormFilePreviewEnable = true;
          this.w9FormfileInput.nativeElement.value = '';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.w9FileDocUrl,
              title: 'W9 Form',
              fileName: this.W9formUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyW9formUrl(this.companyId, this.uploadedFile).subscribe((res) => {
          this.W9formUploadedPath = res;
          this.splittedW9formUploadedPath = this.W9formUploadedPath.split("/");
          this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showW9FormFilePreview = false;
          // setTimeout(() => {
          //   this.showW9FormFilePreview = true;
          // }, 5000);
          // this.showW9FormFilePreview = false;
          this.showW9FormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.w9FileDocUrl,
              title: 'W9 Form',
              fileName: this.W9formUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }

  onDDAutorizationSelect(event) {
    if(event.target.value != '')
    {
      this.DDFileExtension = event.target.value;
      this.DDFileExtension = this.DDFileExtension.split('\\').pop().split('/').pop();
      if (this.DDFileExtension.split('.').pop() == 'pdf' || this.DDFileExtension.split('.').pop() == 'docx' || this.DDFileExtension.split('.').pop() == 'doc' || this.DDFileExtension.split('.').pop() == 'xls' || this.DDFileExtension.split('.').pop() == 'xlsx' || this.DDFileExtension.split('.').pop() == 'PDF' || this.DDFileExtension.split('.').pop() == 'Pdf') {
       
        this.showDDPreview = true;
        this.uploadDDFile();
        this.isDDfileShowsuccessmsg = true;
        this.ddAuthorizationValid = false;
        this.DDfileuploadmessage = this.DDFileExtension;
      }
      else {
        this.showDDFormFilePreviewEnable = false;
        this.ddAuthorizationValid = true;
        this.isDDfileShowsuccessmsg = false;
        this.DDfileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
      }
    }
  }

  @ViewChild('DDAutorizationUpload') DDfileInput;
  uploadDDFile(): void {
    
    this.messageService.add({key: 'dd',severity:'success', summary:'Confirmed', detail:'DD authorization letter uploaded successfully'});
    let fi = this.DDfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedDDFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadDDForm(this.uploadedDDFile).subscribe((res) => {
          this.DDUploadedPath = res;
          this.splittedDDUploadedPath = this.DDUploadedPath.split("/");
          res = res.substring(1);
          this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showDDFormFilePreview = false;
          // setTimeout(() => {
          //   this.showDDFormFilePreview = true;
          // }, 5000);
          // this.showDDFormFilePreview = false;
          this.showDDFormFilePreviewEnable = true;
          this.DDfileInput.nativeElement.value = '';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.ddFileDocUrl,
              title: 'DD Authorization',
              fileName: this.DDUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyDDUrl(this.companyId, this.uploadedDDFile).subscribe((res) => {
          this.DDUploadedPath = res;
          this.splittedDDUploadedPath = this.DDUploadedPath.split("/");
          this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showDDFormFilePreview = false;
          // setTimeout(() => {
          //   this.showDDFormFilePreview = true;
          // }, 5000);
          // this.showDDFormFilePreview = false;
          this.showDDFormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.ddFileDocUrl,
              title: 'DD Authorization',
              fileName: this.DDUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }
  onMSASelect(event) {
    if(event.target.value != '')
    {
    this.MSAFileExtension = event.target.value;
    this.MSAFileExtension = this.MSAFileExtension.split('\\').pop().split('/').pop();
    if (this.MSAFileExtension.split('.').pop() == 'pdf' || this.MSAFileExtension.split('.').pop() == 'docx' || this.MSAFileExtension.split('.').pop() == 'doc' || this.MSAFileExtension.split('.').pop() == 'xls' || this.MSAFileExtension.split('.').pop() == 'xlsx' || this.MSAFileExtension.split('.').pop() == 'PDF' || this.MSAFileExtension.split('.').pop() == 'Pdf') {
      /*const pdfTatget: any = event.target;
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.MSApdfSrc = e.target.result;
        };
        reader.readAsArrayBuffer(pdfTatget.files[0]);
        this.showMSAPreview = true;
        this.uploadMSAFile();
        this.isMSAfileShowsuccessmsg = true;
        this.msaValid = false;
        this.MSAfileuploadmessage = "MSA successfully uploaded";
      }*/
      //this.showMSAFormFilePreviewEnable=true;
      this.showMSAPreview = true;
      this.uploadMSAFile();
      this.isMSAfileShowsuccessmsg = true;
      this.msaValid = false;
      this.MSAfileuploadmessage = this.MSAFileExtension;
      //this.MSAfileuploadmessage = "MSA uploaded successfully";
    }
    else {
      this.showMSAFormFilePreviewEnable = false;
      this.msaValid = true;
      this.isMSAfileShowsuccessmsg = false;
      this.MSAfileuploadmessage = "Please select a valid file format (xls,xlsx,pdf,doc,docx)";
    }
  }
  }

  @ViewChild('MSAUpload') MSAfileInput;
  uploadMSAFile(): void {
    this.messageService.add({key: 'msa',severity:'success', summary:'Confirmed', detail:'MSA successfully uploaded'});
    let fi = this.MSAfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedMSAFile = fi.files[0];
      if (this.userName == undefined) {
        this.registerService.uploadMSAFile(this.uploadedMSAFile).subscribe((res) => {
          this.MSAUploadedPath = res;
          this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
          res = res.substring(1);
          this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showMSAFormFilePreview = false;
          // setTimeout(() => {
          //   this.showMSAFormFilePreview = true;
          // }, 5000);
          // this.showMSAFormFilePreview = false;
          this.showMSAFormFilePreviewEnable = true;
          this.MSAfileInput.nativeElement.value ='';
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.msaFileDocUrl,
              title: 'MSA',
              fileName: this.MSAUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
      else {
        this.registerService.saveCompanyMSAUrl(this.companyId, this.uploadedMSAFile).subscribe((res) => {
          this.MSAUploadedPath = res;
          this.splittedMSAUploadedPath = this.MSAUploadedPath.split("/");
          this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
          this.showMSAFormFilePreview = false;
          // setTimeout(() => {
          //   this.showMSAFormFilePreview = true;
          // }, 5000);
          // this.showMSAFormFilePreview = false;
          this.showMSAFormFilePreviewEnable = true;
          const ref = this.dialogService.open(DocViewerDialogComponent, {
            data: {
              fileUrl: this.msaFileDocUrl,
              title: 'MSA',
              fileName: this.MSAUploadedPath,
            },
            width: '100%',
            height: '100%',
            baseZIndex: 10000,
            showHeader: false,
          });
        });
      }
    }
  }

  getW9FormFile() {
    this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.w9FormFileName;
  }

  getDDAuthorizationFile() {
    this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.ddAuthorizationFileName;
  }

  getMSAFile() {
    this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.msaFileName;
  }

  getInsuranceFile() {
    this.coiFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.insuranceFileName;
  }
  
  Showw9UploadedFile() {
    // this.showW9FormFilePreview = false;
    // setTimeout(() => {
    //   this.showW9FormFilePreview = true;
    // }, 5000);
    // this.showW9FormFilePreview = false;
    // this.showPreview = true;
    console.log(this.w9FormFileName);
    //this.w9FormDownload = this.w9FormFileName;
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.w9FileDocUrl,
        title: 'W9 Form',
        fileName: this.w9FileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowDDAuthorizationUploadedFile() {
    // this.showDDFormFilePreview = false;
    // setTimeout(() => {
    //   this.showDDFormFilePreview = true;
    // }, 5000);
    // this.showDDFormFilePreview = false;
    // this.showDDPreview = true;
    console.log(this.ddFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.ddFileDocUrl,
        title: 'DD Authorization',
        fileName: this.ddFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowMSAUploadedFile() {
    // this.showMSAFormFilePreview = false;
    // setTimeout(() => {
    //   this.showMSAFormFilePreview = true;
    // }, 5000);
    // this.showMSAFormFilePreview = false;
    // this.showMSAPreview = true;
    console.log(this.msaFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.msaFileDocUrl,
        title: 'MSA',
        fileName: this.msaFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  ShowInsuranceUploadedFile() {
    // this.showCOIFormFilePreview = false;
    // setTimeout(() => {
    //   this.showCOIFormFilePreview = true;
    // }, 5000);
    // this.showCOIFormFilePreview = false;
    // this.showInsurancePreview = true;
    console.log(this.coiFileDocUrl);
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.coiFileDocUrl,
        title: 'COI',
        fileName: this.coiFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  getInvoiceTerms() {
    this.categoryName = 'Invoice Terms';
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InvoiceTerms).subscribe((data: any) => {
      this.arrInvoiceTerms = data;
      this.invoiceTerms = this.arrInvoiceTerms.sort((a, b) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
    });
  }
  getInvoiceTermsOnChange(event) {
    this.invoiceTermEnable = true;
    this.invoiceTermsId = event.value.lookupOrder;
  }

  getMSAType(){
    this.categoryName = 'MSA Type';
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.MSAType).subscribe((data: any) => {
    this.MSATypes = data;
    this.arrMSAType=data;
    });
  }

  getMSATypeOnChange(event) {
    this.MSATypeEnable = true;
    this.MSATypeId = event.value.lookupOrder;
  }

  getinsuranceExhibit(){
    this.categoryName = 'Insurance Exhibit A';
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InsuranceExhibitA).subscribe((data: any) => {
    this.arrInsuranceExhibit = data;
    this.insuranceExhibit=this.arrInsuranceExhibit.sort((a, b) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
    });
  }

  getInsuranceExhibitOnChange(event) {
    this.insuranceExhibitEnable = true;
    this.insuranceExhibitId = event.value.lookupOrder;
  }
  validateInput(event: any) {
    const inputChar = event.data;
    if (inputChar && inputChar !== 'x' && isNaN(Number(inputChar))) {
      event.target.value = event.target.value.replace(inputChar, '');
    }
  }
}